import React from 'react';
import './footer.css';
import { motion } from 'framer-motion';

const imageVariant = {
  hover: {
    scale: 1.2,
    transition: {
      delay: 0.3,
      duration: 0.3,
      repeat: 10,
    },
  },
};

export default function Footer() {
  return (
    <div className="footer-container">
      <div className="top-footer">
        <div className="top-one">
          <h5>Mayheaven</h5>
          <div className="socials">
            <motion.a
              variants={imageVariant}
              whileHover="hover"
              href="https://www.linkedin.com/in/oni-toheeb-40358a1b1/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bx bxl-linkedin"></i>
            </motion.a>
            <motion.a
              variants={imageVariant}
              whileHover="hover"
              href="https://web.facebook.com/profile.php?id=100016782519580"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bx bxl-facebook"></i>
            </motion.a>
            <motion.a
              variants={imageVariant}
              whileHover="hover"
              href="https://x.com/OniToheeb3"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bx bxl-twitter"></i>
            </motion.a>
          </div>
        </div>
        <div className="top-two">
          <div className="top-two-box">
            <h5>Product</h5>
            <ul>
              <li><a href="#feature1">Feature 1</a></li>
              <li><a href="#feature2">Feature 2</a></li>
              <li><a href="#feature3">Feature 3</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="#faq">FAQ</a></li>
            </ul>
          </div>
          <div className="top-two-box">
            <h5>Resources</h5>
            <ul>
              <li><a href="#blog">Blog</a></li>
              <li><a href="#guides">Guides</a></li>
              <li><a href="#tutorials">Tutorials</a></li>
              <li><a href="#docs">Documentation</a></li>
              <li><a href="#community">Community</a></li>
            </ul>
          </div>
          <div className="top-two-box">
            <h5>Company</h5>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#careers">Careers</a></li>
              <li><a href="#press">Press</a></li>
              <li><a href="#contact">Contact Us</a></li>
              <li><a href="#privacy">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="newsletter">
        <div className="newsletter-text">
          <h5>Subscribe to our Newsletter</h5>
          <p>Join today and recieve the latest info on cryptocurrency</p>
        </div>
        <form>
          <input type="email" placeholder="Enter your email" />
          <button type="submit">Subscribe</button>
        </form>
      </div>
      <div className="copyright">
        <p>&copy; 2024 Mayheaven. All rights reserved.</p>
      </div>
    </div>
  );
}
